export default "__VITE_ASSET__phOEvCmo__"